import React from "react";
import ColorSection from "./ColorSection";
import FontSizeSection from "./FontSizeSection";

export default function SectionStyleCard({
  title,
  sectionSettings,
  setSectionSettings,
  sectionColors,
  setSectionColors,
  fontSizeFields = [],
}) {
  const safeSectionSettings = {
    useSectionColors: true,
    useSectionFontSizes: false,
    fontSizes: {},
    ...(sectionSettings || {}),
  };

  const handleColorChange = (property, value) => {
    if (!setSectionColors) return;
    setSectionColors((prev) => ({
      ...(prev || {}),
      [property]: value === "transparent" ? "transparent" : value,
    }));
  };

  const toggleSectionColors = (useSectionColors) => {
    if (!setSectionSettings) return;
    setSectionSettings((prev) => ({
      ...(prev || {}),
      useSectionColors,
    }));
  };

  const toggleSectionFontSizes = (useSectionFontSizes) => {
    if (!setSectionSettings) return;
    setSectionSettings((prev) => ({
      ...(prev || {}),
      useSectionFontSizes,
    }));
  };

  const handleFontSizeChange = (key, value) => {
    if (!setSectionSettings) return;
    setSectionSettings((prev) => ({
      ...(prev || {}),
      fontSizes: {
        ...(prev?.fontSizes || {}),
        [key]: value,
      },
    }));
  };

  return (
    <div className="hcfg-card">
      <div className="hcfg-headrow">
        <h3>{title}</h3>
      </div>

      <ColorSection
        title={title}
        colors={sectionColors || {}}
        onColorChange={handleColorChange}
        useSectionColors={safeSectionSettings.useSectionColors !== false}
        onToggleSectionColors={toggleSectionColors}
      />

      {fontSizeFields.length > 0 && (
        <FontSizeSection
          title={title}
          sizes={safeSectionSettings.fontSizes || {}}
          onChange={handleFontSizeChange}
          useSectionFontSizes={safeSectionSettings.useSectionFontSizes === true}
          onToggleSectionFontSizes={toggleSectionFontSizes}
          fields={fontSizeFields}
        />
      )}
    </div>
  );
}
